module.exports = __webpack_public_path__ + "img/rengong.b4ab45a0.png";